import React, { useEffect, useState, useRef } from 'react';
import { Box, Paper, Typography, Button } from '@mui/material';

export default function VideoEditorMusicPage() {
  const [tracks, setTracks] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [msg, setMsg] = useState('');
  const inputRef = useRef(null);
  const tok = localStorage.getItem('dashboard_token');

  const load = () => fetch('/api/editor-music', { headers: { Authorization: 'Bearer ' + tok } })
    .then(r => r.json()).then(d => setTracks(d || [])).catch(() => {});

  useEffect(() => { load(); }, []);

  const upload = async (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    setUploading(true);
    setMsg('');
    try {
      const fd = new FormData();
      fd.append('file', file);
      const r = await fetch('/api/editor-music/upload', { method: 'POST', headers: { Authorization: 'Bearer ' + tok }, body: fd });
      // ВАЖЛИВО показувати причину відмови: раніше тут було просто `if (r.ok)`,
      // тож відхилений сервером трек виглядав як «нічого не сталось» (фідбек OWNER).
      let j = null;
      try { j = await r.json(); } catch (e2) {}
      if (r.ok) {
        setMsg({ type: 'ok', text: '✅ Трек додано' });
        load();
      } else {
        setMsg({ type: 'err', text: '❌ ' + ((j && (j.detail || j.message)) || ('Помилка ' + r.status)) });
      }
    } catch (e) {
      setMsg({ type: 'err', text: '❌ ' + (e.message || 'Не вдалося завантажити') });
    }
    setUploading(false);
    if (inputRef.current) inputRef.current.value = '';
  };

  const toggle = async (id) => {
    await fetch('/api/editor-music/' + id + '/toggle', { method: 'POST', headers: { Authorization: 'Bearer ' + tok } });
    load();
  };

  const del = async (id) => {
    if (!window.confirm('Видалити трек?')) return;
    await fetch('/api/editor-music/' + id, { method: 'DELETE', headers: { Authorization: 'Bearer ' + tok } });
    load();
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" sx={{ color: '#FFD700', mb: 3 }}>🎧 Музика редактора</Typography>
      <Typography sx={{ color: '#888', fontSize: 13, mb: 2 }}>
        Грає у міні-аппі (редактор оверлеїв) на екрані «Обробку запущено», поки юзер чекає на готове відео.
        ОКРЕМА від фонової музики Хаба — власний набір треків, вмикається рандомно.
      </Typography>

      <Paper sx={{ p: 2, bgcolor: '#1a1a2e', border: '1px solid rgba(255,215,0,.28)' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap', mb: 1 }}>
          <Typography sx={{ color: '#FFD700', fontWeight: 'bold' }}>🎵 Треки</Typography>
          <Button size="small" variant="outlined" disabled={uploading} onClick={() => inputRef.current && inputRef.current.click()}
            sx={{ color: '#FFD700', borderColor: '#FFD700', fontSize: 12 }}>
            {uploading ? '⏳ Завантаження…' : '⬆ Додати трек'}
          </Button>
          <input ref={inputRef} type="file" accept="audio/*,.mp3,.ogg,.m4a,.aac,.wav" style={{ display: 'none' }} onChange={upload} />
          <Typography sx={{ color: '#667', fontSize: 11 }}>рандомний трек при старті обробки · макс 12MB</Typography>
        </Box>
        {msg && (
          <Typography sx={{ color: msg.type === 'ok' ? '#34d399' : '#f87171', fontSize: 13, mb: 1 }}>
            {msg.text}
          </Typography>
        )}
        {tracks.length === 0 && <Typography sx={{ color: '#777', fontSize: 12 }}>Ще немає треків. Додай кілька — вмикатимуться рандомно щоразу.</Typography>}
        {tracks.map(tr => (
          <Box key={tr.id} sx={{ display: 'flex', alignItems: 'center', gap: 1, borderBottom: '1px solid #26263e', py: 0.7 }}>
            <span style={{ fontSize: 16 }}>{tr.enabled ? '🎶' : '🔇'}</span>
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography sx={{ color: '#fff', fontSize: 13, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{tr.original_name || tr.filename}</Typography>
              <audio src={tr.url} controls preload="none" style={{ height: 28, width: '100%', maxWidth: 260 }} />
            </Box>
            <Button size="small" onClick={() => toggle(tr.id)} sx={{ color: tr.enabled ? '#34d399' : '#888', fontSize: 11, minWidth: 0 }}>{tr.enabled ? 'вкл' : 'викл'}</Button>
            <Button size="small" onClick={() => del(tr.id)} sx={{ color: '#f87171', fontSize: 11, minWidth: 0 }}>🗑</Button>
          </Box>
        ))}
      </Paper>
    </Box>
  );
}
